/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeUploadManyImagesRequest, type ErrorResponse, type InternalErrorResponse, type UploadManyImagesRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/from-remote
 */
export interface FromRemoteRequestBuilder extends BaseRequestBuilder<FromRemoteRequestBuilder> {
    /**
     * Process and import a list of images with their URLs and optionally associate them with products using SKUs. For an agency organization a row's vendorCode names the line the product belongs to and the row's productSku is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone, so an exported sheet re-imports unchanged; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any image is queued otherwise. A row without a vendorCode uses its productSku exactly as given; a vendorCode cannot be combined with extractSkuFromImageName.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: UploadManyImagesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Process and import a list of images with their URLs and optionally associate them with products using SKUs. For an agency organization a row's vendorCode names the line the product belongs to and the row's productSku is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone, so an exported sheet re-imports unchanged; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any image is queued otherwise. A row without a vendorCode uses its productSku exactly as given; a vendorCode cannot be combined with extractSkuFromImageName.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: UploadManyImagesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FromRemoteRequestBuilderUriTemplate = "{+baseurl}/api/images/from-remote";
/**
 * Metadata for all the requests in the request builder.
 */
export const FromRemoteRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: FromRemoteRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUploadManyImagesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
